/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_ITEMS = `${url}/LOAD_ITEMS`;
export const LOAD_ITEMS_SUCCESS = `${url}/LOAD_ITEMS_SUCCESS`;
export const LOAD_ITEMS_ERROR = `${url}/LOAD_ITEMS_ERROR`;

export const CREATE_ITEMS = `${url}/CREATE_ITEMS`;
export const CREATE_ITEMS_SUCCESS = `${url}/CREATE_ITEMS_SUCCESS`;
export const CREATE_ITEMS_ERROR = `${url}/CREATE_ITEMS_ERROR`;

export const UPDATE_ITEMS = `${url}/UPDATE_ITEMS`;
export const UPDATE_ITEMS_SUCCESS = `${url}/UPDATE_ITEMS_SUCCESS`;
export const UPDATE_ITEMS_ERROR = `${url}/UPDATE_ITEMS_ERROR`;

export const DELETE_ITEMS = `${url}/DELETE_ITEMS`;
export const DELETE_ITEMS_SUCCESS = `${url}/DELETE_ITEMS_SUCCESS`;
export const DELETE_ITEMS_ERROR = `${url}/DELETE_ITEMS_ERROR`;

export const LOAD_ITEMS_RECORDS_META_DATA = `${url}/LOAD_ITEMS_RECORDS_META_DATA`;
export const LOAD_ITEMS_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_ITEMS_RECORDS_META_DATA_SUCCESS`;
export const LOAD_ITEMS_RECORDS_META_DATA_ERROR = `${url}/LOAD_ITEMS_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

//category
export const LOAD_CATEGORY = `${url}/LOAD_CATEGORY`;
export const LOAD_CATEGORY_SUCCESS = `${url}/LOAD_CATEGORY_SUCCESS`;
export const LOAD_CATEGORY_ERROR = `${url}/LOAD_CATEGORY_ERROR`;

export const CREATE_CATEGORY = `${url}/CREATE_CATEGORY`;
export const CREATE_CATEGORY_SUCCESS = `${url}/CREATE_CATEGORY_SUCCESS`;
export const CREATE_CATEGORY_ERROR = `${url}/CREATE_CATEGORY_ERROR`;

export const ADJUST_STOCK = `${url}/ADJUST_STOCK`;
export const ADJUST_STOCK_SUCCESS = `${url}/ADJUST_STOCK_SUCCESS`;
export const ADJUST_STOCK_ERROR = `${url}/ADJUST_STOCK_ERROR`;

export const STOCK_DETAILS = `${url}/STOCK_DETAILS`;
export const STOCK_DETAILS_SUCCESS = `${url}/STOCK_DETAILS_SUCCESS`;
export const STOCK_DETAILS_ERROR = `${url}/STOCK_DETAILS_ERROR`;

export const LOAD_STOCK_VALUE = `${url}/LOAD_STOCK_VALUE`;
export const LOAD_STOCK_VALUE_SUCCESS = `${url}/LOAD_STOCK_VALUE_SUCCESS`;
export const LOAD_STOCK_VALUE_ERROR = `${url}/LOAD_STOCK_VALUE_ERROR`;


export const LOAD_PARTY_WISE_REPORT = `${url}/LOAD_PARTY_WISE_REPORT`;
export const LOAD_PARTY_WISE_REPORT_SUCCESS = `${url}/LOAD_PARTY_WISE_REPORT_SUCCESS`;
export const LOAD_PARTY_WISE_REPORT_ERROR = `${url}/LOAD_PARTY_WISE_REPORT_ERROR`;

const constants = {
  LOAD_ITEMS,
  LOAD_ITEMS_SUCCESS,
  LOAD_ITEMS_ERROR,
  LOAD_STOCK_VALUE,
  LOAD_STOCK_VALUE_SUCCESS,
  LOAD_STOCK_VALUE_ERROR,

  CREATE_ITEMS,
  CREATE_ITEMS_SUCCESS,
  CREATE_ITEMS_ERROR,

  LOAD_CATEGORY,
  LOAD_CATEGORY_SUCCESS,
  LOAD_CATEGORY_ERROR,

  CREATE_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_ERROR,

  STOCK_DETAILS,
  STOCK_DETAILS_SUCCESS,
  STOCK_DETAILS_ERROR,

  LOAD_PARTY_WISE_REPORT,
  LOAD_PARTY_WISE_REPORT_SUCCESS,
  LOAD_PARTY_WISE_REPORT_ERROR,

  ADJUST_STOCK,
  ADJUST_STOCK_SUCCESS,
  ADJUST_STOCK_ERROR,

  UPDATE_ITEMS,
  UPDATE_ITEMS_SUCCESS,
  UPDATE_ITEMS_ERROR,

  DELETE_ITEMS,
  DELETE_ITEMS_SUCCESS,
  DELETE_ITEMS_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_ITEMS_RECORDS_META_DATA,
  LOAD_ITEMS_RECORDS_META_DATA_SUCCESS,
  LOAD_ITEMS_RECORDS_META_DATA_ERROR,
};

export default constants;
